/* Healing Stories Network — theme interactions (vanilla JS, no dependencies)
   v29: PERF-1/PERF-11/NET-9 — hsn-mobile.js and hsn-drawer-suggest.js were merged
   into this file (one script, loaded `defer` from sections/footer.liquid). Every
   block is defensive: it runs on every template, so missing elements are normal. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Sticky header shadow --- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Generic drawer open/close (data-drawer-open="id", data-drawer-close) --- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  var drawerOpener = null;      /* v29: A11Y-4 — element to restore focus to */
  var inertTargets = [];        /* v29: A11Y-4 — page regions made inert while a drawer is open */

  /* v29: PERF-9 — the drawer's 51-collection list is rendered once (desktop #mega2)
     and cloned into the drawer's .drawer-wings placeholder on first open. */
  function fillDrawerWings(drawer) {
    var slot = drawer.querySelector('.drawer-wings[data-clone-from]');
    if (!slot || slot.getAttribute('data-cloned') === '1') return;
    var src = document.getElementById(slot.getAttribute('data-clone-from'));
    if (!src) return;
    var wings = src.querySelectorAll('.mega2-wing');
    for (var i = 0; i < wings.length; i++) {
      var h = wings[i].querySelector('.mega2-h');
      var det = document.createElement('details');
      det.className = 'drawer-wing';
      var sum = document.createElement('summary');
      sum.textContent = h ? h.textContent.trim() : 'Collections';
      var box = document.createElement('div');
      var links = wings[i].querySelectorAll('a');
      for (var j = 0; j < links.length; j++) { box.appendChild(links[j].cloneNode(true)); }
      det.appendChild(sum);
      det.appendChild(box);
      slot.appendChild(det);
    }
    slot.setAttribute('data-cloned', '1');
  }

  function setOpenerState(drawer, expanded) {
    var id = drawer.id;
    if (!id) return;
    var btns = document.querySelectorAll('[data-drawer-open="' + id + '"]');
    for (var i = 0; i < btns.length; i++) { btns[i].setAttribute('aria-expanded', expanded ? 'true' : 'false'); }
  }

  function openDrawer(drawer, opener) {
    if (!drawer) return;
    fillDrawerWings(drawer);
    drawer.classList.add('open');
    var bd = drawer.previousElementSibling;
    if (bd && bd.classList.contains('drawer-backdrop')) bd.classList.add('open');
    document.body.style.overflow = 'hidden';
    /* v29: A11Y-4 — inert the page behind the dialog, remember the opener */
    drawerOpener = opener || document.activeElement;
    inertTargets = [];
    var regions = [document.getElementById('MainContent'), document.querySelector('footer.ftr'), document.querySelector('.site-header')];
    for (var i = 0; i < regions.length; i++) {
      var r = regions[i];
      if (r && !r.contains(drawer) && 'inert' in r) { r.inert = true; inertTargets.push(r); }
    }
    setOpenerState(drawer, true);
    var focusable = (opener && opener.hasAttribute && opener.hasAttribute('data-focus-search')) ? drawer.querySelector('input[type="search"]') : null;
    focusable = focusable || drawer.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 350);
  }
  function closeDrawers() {
    var wasOpen = false;
    document.querySelectorAll('.drawer.open').forEach(function (d) { d.classList.remove('open'); setOpenerState(d, false); wasOpen = true; });
    document.querySelectorAll('.drawer-backdrop.open').forEach(function (b) { b.classList.remove('open'); });
    document.body.style.overflow = '';
    for (var i = 0; i < inertTargets.length; i++) { inertTargets[i].inert = false; }
    inertTargets = [];
    if (wasOpen && drawerOpener && typeof drawerOpener.focus === 'function') {
      try { drawerOpener.focus(); } catch (e) { /* noop */ }
    }
    drawerOpener = null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer-backdrop')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); return; }
    /* v29: A11Y-4 — trap Tab inside an open drawer */
    if (e.key !== 'Tab') return;
    var open = document.querySelector('.drawer.open');
    if (!open) return;
    var items = Array.prototype.filter.call(open.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !open.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !open.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* --- Mobile nav accordion --- */
  document.querySelectorAll('[data-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var t = document.getElementById(btn.getAttribute('data-mobile-toggle'));
      if (t) t.classList.toggle('open-sub');
    });
  });

  /* --- v29: A11Y-3/UX-15 — keyboard-operable mega menu + account menu ---
     Markup: <span class="has-mega"> <a>…</a> <button class="mega-toggle" aria-controls="mega2" aria-expanded> <div id="mega2" hidden> </span>
     Hover still opens via CSS; the button opens for keyboard/touch. */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var wrap = btn.parentElement;
    if (!wrap) return;
    function setOpen(open) {
      panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { panel.removeAttribute('hidden'); wrap.classList.add('is-open'); }
      else { panel.setAttribute('hidden', ''); wrap.classList.remove('is-open'); }
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = btn.getAttribute('aria-expanded') !== 'true';
      setOpen(open);
      /* No focus() here: .mega2 transitions visibility over .22s, so the panel is still
         computed visibility:hidden at this instant and focus() fails silently, dropping focus
         to <body> — which then tripped the focusout handler below and closed the menu again.
         The panel follows the button in DOM order, so Tab reaches it naturally. */
    });
    if (wrap.classList.contains('has-mega')) {
      wrap.addEventListener('mouseenter', function () { setOpen(true); });
      wrap.addEventListener('mouseleave', function () {
        if (!wrap.contains(document.activeElement)) setOpen(false);
      });
    }
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { e.preventDefault(); setOpen(false); btn.focus(); }
    });
    wrap.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !wrap.contains(e.relatedTarget)) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target) && btn.getAttribute('aria-expanded') === 'true') setOpen(false);
    });
  });

  /* --- Live cart count --- */
  window.HSN = window.HSN || {};
  window.HSN.refreshCart = function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      }).catch(function () {});
  };

  /* --- v29: PERF-11/A11Y-15/UX-17 — predictive search (volumes + Reading Room articles),
     one implementation shared by the header box and the drawer box.
     attachSuggest(input, panel, opts): input = <input type="search"> inside a <form>,
     panel = the listbox container, opts.onOpenClose optional. Adds ids/aria-controls,
     ArrowUp/Down + Enter + Escape handling, aria-activedescendant and a polite live
     region announcing the number of suggestions. */
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  function thumb(url) {
    if (!url) return '';
    /* v29: A11Y-15 — request a 96px-wide rendition instead of the full cover */
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=96';
  }
  function attachSuggest(input, panel, opts) {
    if (!input || !panel) return;
    opts = opts || {};
    var form = input.form || input.closest('form');
    if (!form) return;
    var uid = panel.id || ('hsn-suggest-' + Math.floor(Math.random() * 1e6));
    panel.id = uid;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', uid);
    input.setAttribute('aria-haspopup', 'listbox');
    panel.setAttribute('role', 'listbox');
    if (!panel.getAttribute('aria-label')) panel.setAttribute('aria-label', 'Search suggestions');

    var live = document.createElement('span');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    panel.parentNode.insertBefore(live, panel.nextSibling);

    var timer, active = -1, options = [];

    function setActive(n) {
      for (var i = 0; i < options.length; i++) { options[i].removeAttribute('aria-selected'); options[i].classList.remove('is-active'); }
      active = n;
      if (n < 0 || n >= options.length) { input.removeAttribute('aria-activedescendant'); return; }
      options[n].setAttribute('aria-selected', 'true');
      options[n].classList.add('is-active');
      input.setAttribute('aria-activedescendant', options[n].id);
      if (options[n].scrollIntoView) options[n].scrollIntoView({ block: 'nearest' });
    }
    function close() {
      panel.classList.remove('open');
      panel.innerHTML = '';
      options = [];
      setActive(-1);
      input.setAttribute('aria-expanded', 'false');
    }
    function render(products, articles, q) {
      var html = '', n = 0;
      if ((!products || !products.length) && (!articles || !articles.length)) {
        html = '<p class="hdr-suggest__empty">No matches yet. Press Enter to search everything.</p>';
      } else {
        if (products && products.length) {
          html += '<span class="hdr-suggest__h" role="presentation">Volumes</span>';
          for (var i = 0; i < products.length; i++) {
            var p = products[i];
            var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
            html += '<a class="hdr-suggest__item" id="' + uid + '-opt-' + (n++) + '" href="' + esc(p.url) + '" role="option">';
            html += img ? '<img src="' + esc(thumb(img)) + '" alt="" loading="lazy" width="36" height="48">' : '<span class="hdr-suggest__ph"></span>';
            html += '<span class="hdr-suggest__t">' + esc(p.title) + '</span></a>';
          }
        }
        if (articles && articles.length) {
          html += '<span class="hdr-suggest__h" role="presentation">From the Reading Room</span>';
          for (var j = 0; j < articles.length; j++) {
            html += '<a class="hdr-suggest__art" id="' + uid + '-opt-' + (n++) + '" href="' + esc(articles[j].url) + '" role="option">' + esc(articles[j].title) + '</a>';
          }
        }
        html += '<a class="hdr-suggest__all" id="' + uid + '-opt-' + (n++) + '" role="option" href="' + esc(form.getAttribute('action')) +
                '?type=product,page&options[prefix]=last&q=' + encodeURIComponent(q) +
                '">See all results for “' + esc(q) + '” →</a>';
      }
      panel.innerHTML = html;
      panel.classList.add('open');
      input.setAttribute('aria-expanded', 'true');
      options = Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
      setActive(-1);
      var count = (products ? products.length : 0) + (articles ? articles.length : 0);
      live.textContent = count ? (count + (count === 1 ? ' suggestion' : ' suggestions') + ' available, use up and down arrows to review') : 'No suggestions';
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=5' +
              '&resources[options][unavailable_products]=last',
              { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = (d && d.resources && d.resources.results) || {};
            if (input.value.trim() === q) { render(res.products || [], res.articles || [], q); }
          })
          .catch(function () { close(); });
      }, 180);
    });
    input.addEventListener('focus', function () { if (panel.innerHTML) { panel.classList.add('open'); input.setAttribute('aria-expanded', 'true'); } });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (!panel.classList.contains('open') || !options.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1 >= options.length ? 0 : active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1 < 0 ? options.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active >= 0 && options[active]) { e.preventDefault(); window.location.href = options[active].href; }
      // v29 fix: Home/End are NOT intercepted. The suggestion panel lives under a text
      // input, so swallowing them stops the caret jumping to the start/end of the query.
      // v28 intercepted only Escape; ArrowUp/ArrowDown/Enter are enough to drive the list.
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target) && !panel.contains(e.target)) { close(); }
      if (e.target.closest && (e.target.closest('[data-drawer-close]') || e.target.closest('.drawer-backdrop'))) { close(); }
    });
  }
  window.HSN.attachSuggest = attachSuggest;

  /* Header inline search */
  (function () {
    var form = document.querySelector('.hdr-search');
    if (!form) return;
    attachSuggest(form.querySelector('.hdr-search__in'), form.querySelector('.hdr-suggest'));
  })();

  /* Drawer search (the header's mobile search icon opens the drawer and focuses this field) */
  (function () {
    var drawer = document.getElementById('MobileDrawer');
    if (!drawer) return;
    var form = drawer.querySelector('.drawer-search');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    var panel = drawer.querySelector('.drawer-suggest');
    if (!input) return;
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'drawer-suggest';
      panel.id = 'drawer-suggest';
      form.parentNode.insertBefore(panel, form.nextSibling);
    }
    attachSuggest(input, panel);
  })();

  /* --- v29: PERF-1 — mobile-only enhancements (formerly hsn-mobile.js).
     Sticky add-to-cart bar on product pages: on a phone the buy button scrolls out
     of view within a screen or two. Styles are static in sections/header.liquid
     (no runtime CSS injection). The bar is appended to <body>, never into .pdp. */
  (function () {
    if (window.matchMedia && !window.matchMedia('(max-width: 900px)').matches) return;
    if (!document.body.classList.contains('template-product')) return;

    var realForm = document.querySelector('form[action*="/cart/add"]');
    if (!realForm) return;
    var realBtn = realForm.querySelector('button[name="add"]');
    if (!realBtn) return;

    /* v29: UX-1 — title = .pdp-title-main, plus " — " + .pdp-title-sub when present (fallback h1). */
    var mainEl = document.querySelector('.pdp-title-main');
    var subEl = document.querySelector('.pdp-title-sub');
    var title = '';
    if (mainEl) {
      title = mainEl.textContent.trim();
      if (subEl && subEl.textContent.trim()) title += ' — ' + subEl.textContent.trim();
    } else {
      var h1 = document.querySelector('.pdp-info h1') || document.querySelector('h1');
      title = h1 ? h1.textContent.trim() : '';
    }
    if (title.length > 60) title = title.slice(0, 58).trim() + '…';

    /* Price: .pdp-price contains three spans — current price, optional
       strikethrough compare-at, and an edition label. Take the first only. */
    var priceSpan = document.querySelector('.pdp-price > span:first-child');
    var price = priceSpan ? priceSpan.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'hsn-buybar';
    bar.innerHTML =
      '<span class="hsn-buybar__txt">' +
        '<span class="hsn-buybar__t"></span>' +
        '<span class="hsn-buybar__p"></span>' +
      '</span>' +
      '<button class="hsn-buybar__btn" type="button">Add to cart</button>';
    bar.querySelector('.hsn-buybar__t').textContent = title;
    bar.querySelector('.hsn-buybar__p').textContent = price;
    document.body.appendChild(bar);

    bar.querySelector('.hsn-buybar__btn').addEventListener('click', function () {
      realBtn.click();
    });

    if ('IntersectionObserver' in window) {
      var bio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { rootMargin: '0px 0px -60px 0px' });
      bio.observe(realBtn);
    } else {
      bar.classList.add('is-show');
    }

    /* Hide the bar while the sample-page lightbox is open (works for the legacy
       [hidden] div and for the <dialog> version that uses the open attribute). */
    var lb = document.getElementById('pdpLightbox');
    if (lb && 'MutationObserver' in window) {
      var lbOpen = function () {
        return lb.tagName === 'DIALOG' ? lb.hasAttribute('open') : !lb.hasAttribute('hidden');
      };
      new MutationObserver(function () {
        bar.style.display = lbOpen() ? 'none' : '';
      }).observe(lb, { attributes: true, attributeFilter: ['hidden', 'open'] });
    }
  })();

  window.HSN.reduceMotion = reduceMotion;
})();
